import { Translation } from '@ps/web-shared-components';
import React from 'react';

import BonusStep from '../../../../assets/icons/activestepbonus.svg';
import CompletedStepIcon from '../../../../assets/icons/completedstep.svg';

import { TXTCLI_Bonus } from './BonusStepActive.messages.json';

interface BonusActiveProps {
  classname: string;
}

const BonusStepActive = ({ classname }: BonusActiveProps) => (
  <>
    <CompletedStepIcon />
    <CompletedStepIcon />
    <CompletedStepIcon />
    <div className={classname}>
      <BonusStep />
      <p>
        <Translation {...TXTCLI_Bonus} />
      </p>
    </div>
  </>
);

export default BonusStepActive;
